import { atom } from 'jotai'

export const devModeAtom = atom(false)
